// @ts-nocheck

import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { tripInspectionFrequencyApi } from '../../lib/api';


import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';





const entryPointPath = '/admin/trip-inspection-frequency/';

export default (props) => {
  const [data, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await tripInspectionFrequencyApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload) => {
    let id = payload.id;
    if (id) {
      await tripInspectionFrequencyApi.update(payload);
    } else {
      let data = await tripInspectionFrequencyApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload) => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader:
        'Периодичность проведения предрейсовых/послерейсовых осмотров'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}>

      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>);

};